import { Link } from '@curie/react'
import { CurieLogo } from '../icons'

const CampaignFooter = () => {
  return (
    <footer className="h-fit bg-black text-white pt-24 pb-16 w-screen">
      <div className="max-w-screen mx-auto px-32">
        <div className="mb-16">
          <Link href='/' className='flex items-center'>
            <CurieLogo className='text-white w-60 h-40' />
          </Link>
        </div>
        <nav className="flex flex-wrap justify-between items-center mb-8">
          <div className="flex space-x-8 text-lg opacity-60">
            <Link href="https://www.curietech.ai/" className='text-white'>Home</Link>
            <Link href="https://www.curietech.ai/security" className='text-white'>Security</Link>
            <Link href="https://www.curietech.ai/about" className='text-white'>About</Link>
            <Link href="https://www.curietech.ai/careers" className='text-white'>Careers</Link>
            <Link href="https://trust.curietech.ai/" className='text-white'>Trust Center</Link>
            <Link href="https://www.curietech.ai/contact-us" className='text-white'>Contact</Link>
          </div>

          <div>
            <Link href="https://www.linkedin.com/company/curietech-inc/" className='text-white text-lg'>LinkedIn</Link>
          </div>
        </nav>

        <div className="border-t border-white/10 pt-8 flex justify-between items-center">
          <p className="text-md opacity-40">© Curie — All rights reserved.</p>
          <div className="flex space-x-6 text-md">
            <Link href="https://www.curietech.ai/terms" className="opacity-70">Terms</Link>
            <Link href="https://www.curietech.ai/privacy" className="opacity-70">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default CampaignFooter
